(function () {
    'use strict';

    angular
        .module('elogbooks.common.dashboard-layout')
        .config(registerRoutes);

    function registerRoutes ($stateProvider) {

        $stateProvider
            .state('dashboard', {
                abstract: true,
                resolve: {
                    // Root resource for logged in user
                    rootResourceResponse: function (apiClient, $rootScope, $window, userManager) {
                        // Reuse the copy the login flow already fetched, if there is one.
                        let primed = userManager.consumeRootResource();

                        if (primed) {
                            $rootScope.theme = primed?.theme;
                            return primed;
                        }

                        let url = '/';

                        if (window.localStorage.getItem('originalUser') === null) {
                            url = '/?dashboard=1';
                        }

                        return apiClient.get(url).then(function(response) {
                            $rootScope.theme = response?.theme;

                            if (response && response.getLink && response.getLink('user') && response.getLink('token')) {
                                $window.localStorage.setItem('userResource', response.getLink('user'));
                                $window.localStorage.setItem('tokenLink', response.getLink('token'));
                            }

                            return response;
                        });
                    },
                    user: function (userManager, rootResourceResponse, $q, $state, $window, localeManager) {
                        if (!rootResourceResponse || !rootResourceResponse.getLink || !rootResourceResponse.getLink('user')) {
                            // Authenticated but unverified: root omits the user link.
                            if (rootResourceResponse && rootResourceResponse.getLink && $window.localStorage.getItem('token')) {
                                $state.go('email.verification');
                                return $q.reject('USER_NEED_EMAIL_VERIFICATION');
                            }

                            return $q.reject('NOT_AUTHENTICATED');
                        }

                        var primedUser = userManager.consumeUser();
                        var userPromise = primedUser ? $q.when(primedUser) : userManager.getUser();

                        return userPromise.then(function (userResponse) {
                            if (
                                $state.next.name !== 'sso' &&
                                $state.next.name !== 'dashboard.change-password' &&
                                $state.next.name !== 'dashboard.terms-of-use' &&
                                userResponse.shouldChangePassword &&
                                ! userManager.skippedChangePassword
                            ) {
                                $state.go('dashboard.change-password');
                            }

                            localeManager.set(userManager.getPreferenceValue('locale'));
                            return userResponse;
                        })
                    },
                    userPreferences: function ($stateParams, userManager) {
                        return userManager.getPreferences($stateParams.reloadUserPreferences);
                    },
                    siteCollectionResponse: function(apiClient, user, globalFilterParamsService) {
                        var params = {
                            datagroup: 'search'
                        };

                        params = angular.extend({}, params, globalFilterParamsService.getLocalStorageFilters());

                        return apiClient.get(user.getLink('sites'), params, 'long').then(function(response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    userCollectionResponse: function(rootResourceResponse, apiClient, user) {
                        if (window.localStorage.getItem('siteAssociateTypeFilter')) {
                            var params = { status: 'active' };
                            params.siteAssociateType = window.localStorage.getItem('siteAssociateTypeFilter') || null;

                            return apiClient.get(user.getLink('users'), params);
                        }
                        return null;
                    },
                    modules: function (modulesService) {
                        return modulesService.getAll();
                    },
                    modulesEnabled: function (modulesService, rootResourceResponse) {
                        return modulesService.load(rootResourceResponse);
                    },
                    settings: function (rootResourceResponse, $window, elbSettings) {
                        if (rootResourceResponse.getLink('settings') !== null) {
                            $window.localStorage.setItem('settingsUrl', rootResourceResponse.getLink('settings'));

                            return elbSettings.getSettings(true, rootResourceResponse.getLink('settings'));
                        }

                        return [];
                    }
                },
                params: {
                    reloadUserPreferences: null
                },
                ncyBreadcrumb: {
                    skip: true
                },
                templateUrl: '/modules/common/dashboard-layout/dashboard-layout.html',
                controller: 'DashboardLayoutController',
                controllerAs: 'vm'
            });
    }

})();
